/*
 * @Description:
 * @Date: 2025-06-23 11:13:28
 */
import {
  InvoiceUninvoicedList,
  InvoiceUninvoicedListPlatform,
  InvoiceUninvoicedListGt
} from '../components/invoice-uninvoiced-list';
import InvoiceRecordList from '../components/invoice-record-list/invoice-record-list.vue';
import InvoiceRecordGtList from '../components/invoice-record-list/invoice-record-gt-list.vue';
import InvoiceRecordPlatformList from '../components/invoice-record-list/invoice-record-platform-list.vue';
import InvoiceRecordDbgysList from '../components/invoice-record-list/invoice-record-dbgys-list.vue';
import InvoiceFilingList from '../components/invoice-filing-list.vue';
import { InvoiceDjsjList } from '../components/invoice-djsj';

/**  旧版平铺TAB，保留兼容 */
export const TABS = {
  1: { label: '未开票订单', value: 1, cmpt: InvoiceUninvoicedList },
  2: { label: '开票记录', value: 2, cmpt: InvoiceRecordList },
  4: { label: '个体发票上传', value: 4, cmpt: InvoiceUninvoicedListGt },
  3: { label: '开票备案', value: 3, cmpt: InvoiceFilingList },
  5: { label: '代缴税金', value: 5, cmpt: InvoiceDjsjList }
};

/**
 * 服务商端发票管理 → 4个主Tab（个体/自然人/平台/工业），每个含子Tab
 */
export const MAIN_TABS = {
  /** 个体发票: 待开票数据 + 开票记录 */
  1: {
    label: '个体发票',
    value: 1,
    children: {
      1: { label: '待开票数据', value: 1, cmpt: InvoiceUninvoicedListGt },
      2: { label: '开票记录', value: 2, cmpt: InvoiceRecordGtList, type: 1 }
    }
  },
  /** 自然人发票: 搬迁自旧服务商/供应商/委托代开发票，功能不变 */
  2: {
    label: '自然人发票',
    value: 2,
    children: {
      1: { label: '待开票数据', value: 1, cmpt: InvoiceUninvoicedList },
      2: { label: '开票记录', value: 2, cmpt: InvoiceRecordList, type: 2 }
    }
  },
  /** 平台发票: 平台服务费/商务服务费/技术服务费 */
  3: {
    label: '平台发票',
    value: 3,
    children: {
      1: { label: '待开票数据', value: 1, cmpt: InvoiceUninvoicedListPlatform },
      2: {
        label: '开票记录',
        value: 2,
        cmpt: InvoiceRecordPlatformList,
        type: 3
      }
    }
  },
  /** 工业发票: 工业上传发票给服务商 */
  4: {
    label: '工业发票',
    value: 4,
    children: {
      1: { label: '开票记录', value: 1, cmpt: InvoiceFilingList }
    }
  }
} as const;

/**
 * 代办供应商端Tab（票税修改）
 * 代办供应商只有个体发票一个主Tab，待开票数据用InvoiceUninvoicedList
 */
export const DBGYS_TABS = {
  1: { label: '待开票数据', value: 1, cmpt: InvoiceUninvoicedListGt, type: 11 },
  2: { label: '开票记录', value: 2, cmpt: InvoiceRecordDbgysList, type: 1 }
} as const;

/** 代办供应商订单类型（项目服务费 / 个体税金及服务费） */
export const DBGYS_ORDER_TYPE = {
  1: { label: '项目服务费', value: 1 },
  10: { label: '个体税金及服务费', value: 10 }
};

export const INVOICE_TYPE = {
  1: { label: '增值税普通发票', value: 1 },
  2: { label: '增值税专用发票', value: 2 }
};
export const INVOICE_METHODS = {
  0: { label: '纸质发票', value: 0 },
  1: { label: '电子发票', value: 1 }
};
// C端发票状态
export const C_INVOICE_STATUS = {
  0: { label: '未开票', value: 0 },
  1: { label: '待审核', value: 1 },
  2: { label: '已开票', value: 2 },
  3: { label: '已驳回', value: 3 }
};
// 平台发票状态（票税修改 v2 后端确认版 2026-06-03）
// 蓝票字段 blueInvoiceStatus: -2, 0, 1, 2, 3, 11, 12, 13
// 红票字段 redInvoiceStatus:  4, 5, 6, 7, 8, 9, 10
export const INVOICE_STATUS = {
  [-2]: { label: '待个体确认开票', value: -2 },
  [-1]: { label: '申请开票驳回', value: -1 },
  0: { label: '待开票', value: 0 },
  1: { label: '待审核', value: 1 },
  2: { label: '已开票', value: 2 },
  3: { label: '购方已驳回', value: 3 },
  4: { label: '待红冲发票', value: 4 },
  5: { label: '红冲待审核', value: 5 },
  6: { label: '全部冲红', value: 6 },
  7: { label: '购方已驳回红冲', value: 7 },
  8: { label: '待个体确认冲红', value: 8 },
  9: { label: '冲红申请驳回', value: 9 },
  10: { label: '部分冲红', value: 10 },
  11: { label: '延迟开票', value: 11 },
  12: { label: '部分开票', value: 12 },
  13: { label: '拒绝开票', value: 13 }
};

/** 蓝票状态（blueInvoiceStatus 字段） */
export const BLUE_INVOICE_STATUS = {
  [-2]: { label: '待个体确认开票', value: -2 },
  0: { label: '待开票', value: 0 },
  1: { label: '待审核', value: 1 },
  2: { label: '已开票', value: 2 },
  3: { label: '购方已驳回', value: 3 },
  11: { label: '延迟开票', value: 11 },
  12: { label: '部分开票', value: 12 },
  13: { label: '拒绝开票', value: 13 }
};

/** 红票状态（redInvoiceStatus 字段） */
export const RED_INVOICE_STATUS = {
  8: { label: '待个体确认冲红', value: 8 },
  9: { label: '冲红申请驳回', value: 9 },
  4: { label: '待红冲发票', value: 4 },
  5: { label: '红冲待审核', value: 5 },
  7: { label: '购方已驳回红冲', value: 7 },
  10: { label: '部分冲红', value: 10 },
  6: { label: '全部冲红', value: 6 }
};

/** 平台发票蓝票状态（blueInvoiceStatus 字段，平台专用） */
export const PLATFORM_BLUE_INVOICE_STATUS = {
  0: { label: '待开票', value: 0 },
  2: { label: '已开票', value: 2 },
  3: { label: '驳回开票', value: 3 }
};

/** 平台发票红票状态（redInvoiceStatus 字段，平台专用） */
export const PLATFORM_RED_INVOICE_STATUS = {
  6: { label: '全部冲红', value: 6 },
  8: { label: '申请冲红', value: 8 },
  10: { label: '部分冲红', value: 10 }
};

export const ALL_INVOICE_STATUS = {
  ...INVOICE_STATUS
};
export const MAIL_TYPE = {
  0: { label: '非邮寄', value: 0 },
  1: { label: '邮寄', value: 1 }
};
export const INVOICE_FUNCTION = {
  1: { label: '蓝票', value: 1 },
  2: { label: '红票', value: 2 }
};
export const INVOICE_AUDIT_TYPE = {
  0: { label: '发票驳回', value: 0 },
  1: { label: '发票通过', value: 1 }
};
// 工业发票状态，改状态可能有问题，应该和C_INVOICE_STATUS一致
export const OFFLINE_INVOICE_STATUS = {
  0: { label: '未提交', value: 0 },
  1: { label: '待开票', value: 1 },
  2: { label: '待确认', value: 2 },
  3: { label: '已驳回', value: 3 },
  4: { label: '已开票', value: 4 }
};
// 个体开票状态
export const INVOICE_GT_STATUS = {
  1: { label: '未上传', value: 1 },
  2: { label: '已上传', value: 2 }
};
/** 申报方式: 1月度 2季度 */
export const DECLARE_METHOD = {
  1: { label: '月度', value: 1 },
  2: { label: '季度', value: 2 }
};
/** 代缴税金审核状态常量: 0待上传 1平台审核中 2审核通过 3审核驳回 */
export const PROXY_TAX_AUDIT_STATUS = {
  0: { label: '待上传', value: 0 },
  1: { label: '平台审核中', value: 1 },
  2: { label: '审核通过', value: 2 },
  3: { label: '审核驳回', value: 3 }
};
export const SETTLEMENT_STATUS_OPTIONS = [
  { label: '待支付', value: 0 },
  { label: '支付中', value: 1 },
  { label: '部分支付成功', value: 2 },
  { label: '支付成功', value: 3 },
  { label: '支付失败', value: 3 }
];
